/**
 * [INPUT]: 依赖 sonner、lucide-react 与全局语义色/阴影 tokens
 * [OUTPUT]: 对外提供 Toaster 通知容器
 * [POS]: zinnercms-design-system/ui 的全局短时反馈出口，将通知收敛为白纸浮层而非彩色大块提示
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { Toaster as Sonner } from "sonner"

function Toaster({ ...props }) {
  return (
    <Sonner
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          toast: "group toast rounded-xl border border-border bg-popover text-popover-foreground shadow-lg",
          title: "text-[13px] font-semibold text-foreground",
          description: "text-xs leading-relaxed text-muted-foreground",
          actionButton: "rounded-md bg-foreground text-background",
          cancelButton: "rounded-md border border-border bg-muted text-muted-foreground",
          success: "border-secondary/50",
          error: "border-destructive/50",
        }
      }}
      {...props}
    />
  )
}

export { Toaster }
